<template>
  <label class="form-label">
    {{ $t('common.days.list') }}
  </label>
  <div v-for="day in days" :key="day.dayIndex">
    <input
      :id="day.dayIndex"
      class="form-check-input"
      type="checkbox"
      v-model="selectedDays"
      :value="day.dayIndex"
      :key="day.dayIndex"
      @change="$emit('update:modelValue', selectedDays)"
    />
    <label class="form-check-label" :for="day.dayIndex">
      {{ $t(day.dayName) }}
    </label>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  data() {
    return {
      days: [
        {
          dayIndex: 1,
          dayName: 'common.days.monday'
        },
        {
          dayIndex: 2,
          dayName: 'common.days.tuesday'
        },
        {
          dayIndex: 3,
          dayName: 'common.days.wednesday'
        },
        {
          dayIndex: 4,
          dayName: 'common.days.thursday'
        },
        {
          dayIndex: 5,
          dayName: 'common.days.friday'
        },
        {
          dayIndex: 6,
          dayName: 'common.days.saturday'
        },
        {
          dayIndex: 7,
          dayName: 'common.days.sunday'
        }
      ]
    }
  },

  setup() {
    const selectedDays = ref([])

    return {
      selectedDays
    }
  }
})
</script>
